import '../../sass/EEBusiness/index.scss'

const configNode = document.getElementById('EEBusinessPaymentConfig')
const billingForm = document.querySelector('.js-ee-business-billing-form')
const stripeForm = document.querySelector('.js-ee-business-stripe-form')
const billingErrorBox = document.querySelector('.js-ee-business-payment-error')
const stripeErrorBox = document.querySelector('.js-ee-business-stripe-error')
const loader = document.querySelector('.js-ee-business-payment-loader')
const payButton = document.querySelector('.js-ee-business-pay-button')
const prepareButton = document.querySelector('.js-ee-business-prepare-payment')
const summaryNode = document.querySelector('.js-ee-business-payment-summary')
const summaryLoader = document.querySelector('.js-ee-business-summary-loader')
const billingEditable = document.querySelector('.js-ee-business-billing-editable')
const billingReview = document.querySelector('.js-ee-business-billing-review')
const billingEditButton = document.querySelector('.js-ee-business-edit-billing')
const termsModal = document.querySelector('.js-ee-business-terms-modal')
const termsModalDialog = termsModal?.querySelector('.EEBusiness-TermsModalDialog')
const termsOpenButtons = document.querySelectorAll('.js-ee-business-terms-open')
const termsCloseButtons = document.querySelectorAll('.js-ee-business-terms-close')
const termsAcceptButton = document.querySelector('.js-ee-business-terms-accept')

if (configNode && billingForm) {
    let config = {}
    try {
        config = JSON.parse(configNode.textContent || '{}')
    } catch (e) {
        config = {}
    }

    const texts = config.texts || {}
    let stripe = null
    let elements = null
    let paymentElement = null
    let currentClientSecret = config.clientSecret || ''
    let statusTimer = null
    let summaryTimer = null
    let summaryRequestToken = 0
    let lastTermsTrigger = null

    function getText(key, fallback) {
        const value = texts[key]
        return typeof value === 'string' && value ? value : fallback
    }

    function setLoading(isLoading) {
        if (loader) {
            loader.hidden = !isLoading
            loader.setAttribute('aria-hidden', isLoading ? 'false' : 'true')
        }

        if (prepareButton) {
            prepareButton.disabled = isLoading
        }
        if (payButton) {
            payButton.disabled = isLoading
        }
    }

    function setSummaryLoading(isLoading) {
        if (!summaryLoader) {
            return
        }

        summaryLoader.hidden = !isLoading
        summaryLoader.setAttribute('aria-hidden', isLoading ? 'false' : 'true')
    }

    function showError(target, message) {
        if (!target) {
            return
        }

        target.textContent = message || getText('genericError', 'Something went wrong. Please try again.')
        target.hidden = false
        target.style.display = 'block'
        target.scrollIntoView({behavior: 'smooth', block: 'nearest'})
    }

    function showBillingError(message) {
        showError(billingErrorBox, message)
    }

    function showStripeError(message) {
        showError(stripeErrorBox, message)
    }

    function clearError(target) {
        if (!target) {
            return
        }

        target.textContent = ''
        target.hidden = true
        target.style.display = 'none'
    }

    function clearErrors() {
        clearError(billingErrorBox)
        clearError(stripeErrorBox)
    }

    async function responseToJson(response) {
        try {
            return await response.clone().json()
        } catch (e) {
            return {}
        }
    }

    function updateCompanyFields() {
        const type = billingForm.querySelector('input[name="customer_type"]:checked')?.value || 'individual'
        const isCompany = type === 'company'

        billingForm.querySelectorAll('.js-company-field').forEach((field) => {
            field.hidden = !isCompany
            const input = field.querySelector('input')
            if (input) {
                input.required = isCompany && input.name === 'company_name'
            }
        })

        billingForm.querySelectorAll('.js-address-field').forEach((field) => {
            field.hidden = !isCompany
            const input = field.querySelector('input')
            if (input) {
                input.required = isCompany && ['address_line1', 'city', 'postal_code'].includes(input.name)
            }
        })
    }

    function updateSummary(summary) {
        if (!summaryNode || !summary) {
            return
        }

        Object.entries({
            subtotal: summary.subtotal,
            vat: summary.vat,
            total: summary.total,
        }).forEach(([key, value]) => {
            const target = summaryNode.querySelector(`[data-summary-field="${key}"]`)
            if (target && typeof value === 'string') {
                target.textContent = value
            }
        })
    }

    function billingDetails() {
        const formData = new FormData(billingForm)
        const isCompany = formData.get('customer_type') === 'company'

        return {
            name: isCompany
                ? `${formData.get('company_name') || ''} / ${formData.get('customer_name') || ''}`.trim()
                : String(formData.get('customer_name') || ''),
            email: String(config.email || ''),
            address: {
                country: String(formData.get('country_code') || ''),
                line1: isCompany ? String(formData.get('address_line1') || '') : '',
                line2: isCompany ? String(formData.get('address_line2') || '') : '',
                city: isCompany ? String(formData.get('city') || '') : '',
                postal_code: isCompany ? String(formData.get('postal_code') || '') : '',
                state: isCompany ? String(formData.get('state') || '') : '',
            },
        }
    }

    function selectedCustomerTypeLabel() {
        return billingForm.querySelector('input[name="customer_type"]:checked + span')?.textContent?.trim() || ''
    }

    function selectedCountryLabel() {
        return billingForm.querySelector('select[name="country_code"] option:checked')?.textContent?.trim() || ''
    }

    function setReviewText(key, value) {
        const target = billingReview?.querySelector(`[data-billing-review="${key}"]`)
        if (!target) {
            return
        }

        target.textContent = value || ''
        target.hidden = !value
    }

    function updateBillingReview() {
        if (!billingReview) {
            return
        }

        const formData = new FormData(billingForm)
        const isCompany = formData.get('customer_type') === 'company'
        const customerName = String(formData.get('customer_name') || '').trim()
        const companyName = String(formData.get('company_name') || '').trim()
        const registryCode = String(formData.get('company_registry_code') || '').trim()
        const vatNumber = String(formData.get('vat_number') || '').trim()
        const secondary = [selectedCustomerTypeLabel()]

        if (isCompany && customerName) {
            secondary.push(customerName)
        }
        if (isCompany && registryCode) {
            secondary.push(registryCode)
        }

        setReviewText('primary', isCompany ? (companyName || customerName) : customerName)
        setReviewText('secondary', secondary.filter(Boolean).join(' · '))
        setReviewText('country', selectedCountryLabel())
        setReviewText('vat', vatNumber ? `VAT ${vatNumber}` : '')
    }

    function setBillingCollapsed(isCollapsed) {
        billingForm.classList.toggle('is-collapsed', isCollapsed)
        billingForm.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true')

        if (billingEditable) {
            billingEditable.hidden = isCollapsed
        }
        if (billingReview) {
            billingReview.hidden = !isCollapsed
        }
        if (billingEditButton) {
            billingEditButton.hidden = !isCollapsed
        }
        if (prepareButton) {
            prepareButton.hidden = isCollapsed
        }

        if (isCollapsed) {
            updateBillingReview()
        }
    }

    function resetPaymentElement() {
        if (paymentElement && typeof paymentElement.unmount === 'function') {
            paymentElement.unmount()
        }

        paymentElement = null
        elements = null
        currentClientSecret = ''
    }

    function markPaymentDetailsChanged() {
        if (stripeForm) {
            stripeForm.hidden = true
        }
    }

    function scheduleSummaryUpdate() {
        if (!config.summaryUrl) {
            setSummaryLoading(false)
            return
        }

        const requestToken = ++summaryRequestToken
        setSummaryLoading(true)

        if (summaryTimer) {
            clearTimeout(summaryTimer)
        }

        summaryTimer = window.setTimeout(() => updateSummaryFromServer(requestToken), 420)
    }

    async function updateSummaryFromServer(requestToken) {
        summaryTimer = null

        try {
            const response = await fetch(config.summaryUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'xmlhttprequest',
                },
                body: new FormData(billingForm),
            })
            const payload = await responseToJson(response)
            if (response.ok && payload.summary) {
                updateSummary(payload.summary)
            }
        } catch (e) {
            // Summary refresh is advisory; final validation happens before payment.
        } finally {
            if (requestToken === summaryRequestToken) {
                setSummaryLoading(false)
            }
        }
    }

    function inputAffectsSummary(input) {
        return ['country_code', 'customer_type', 'vat_number'].includes(input.name)
    }

    function paymentConsentsAccepted() {
        const consents = Array.from(billingForm.querySelectorAll('.js-ee-business-payment-consent'))

        return consents.length === 0 || consents.every((input) => input.checked)
    }

    function openTermsModal(event) {
        event.preventDefault()
        event.stopPropagation()

        if (!termsModal) {
            return
        }

        if (termsModal.parentElement !== document.body) {
            document.body.appendChild(termsModal)
        }

        lastTermsTrigger = event.currentTarget
        termsModal.hidden = false
        termsModal.setAttribute('aria-hidden', 'false')
        document.documentElement.classList.add('EEBusiness-TermsModalOpen')
        document.body.classList.add('EEBusiness-TermsModalOpen')
        window.setTimeout(() => termsModalDialog?.focus(), 0)
    }

    function closeTermsModal(event) {
        if (event) {
            event.preventDefault()
        }

        if (!termsModal) {
            return
        }

        termsModal.hidden = true
        termsModal.setAttribute('aria-hidden', 'true')
        document.documentElement.classList.remove('EEBusiness-TermsModalOpen')
        document.body.classList.remove('EEBusiness-TermsModalOpen')

        if (lastTermsTrigger && typeof lastTermsTrigger.focus === 'function') {
            lastTermsTrigger.focus()
        }
    }

    function acceptTermsModal(event) {
        if (event) {
            event.preventDefault()
        }

        const termsCheckbox = billingForm.querySelector('input[name="payment_consent_terms_of_service"]')
        if (termsCheckbox) {
            termsCheckbox.checked = true
            termsCheckbox.dispatchEvent(new Event('change', {bubbles: true}))
        }

        closeTermsModal(event)
    }

    function initStripe(clientSecret) {
        if (!window.Stripe) {
            throw new Error('Stripe.js did not load. Please refresh the page and try again.')
        }

        if (!stripe) {
            stripe = window.Stripe(config.stripePublicKey || document.body.dataset.stripePublicKey || '')
        }

        if (paymentElement && currentClientSecret === clientSecret) {
            return
        }

        if (paymentElement && currentClientSecret !== clientSecret && typeof paymentElement.unmount === 'function') {
            paymentElement.unmount()
            paymentElement = null
        }

        currentClientSecret = clientSecret
        const appearance = {
            theme: 'stripe',
            variables: {
                colorPrimary: '#e20036',
                borderRadius: '10px',
                fontFamily: 'Inter, Arial, sans-serif',
            },
        }

        elements = stripe.elements({clientSecret, appearance})
        const stripeBillingDetails = billingDetails()
        paymentElement = elements.create('payment', {
            layout: {
                type: 'tabs',
                defaultCollapsed: false,
            },
            defaultValues: {
                billingDetails: stripeBillingDetails,
            },
            fields: {
                billingDetails: {
                    name: 'never',
                    email: 'never',
                    address: {
                        country: 'never',
                    },
                },
            },
            wallets: {
                applePay: 'auto',
                googlePay: 'auto',
                link: 'never',
            },
        })
        paymentElement.mount('#EEBusinessStripePaymentElement')
    }

    async function preparePayment(event) {
        event.preventDefault()
        clearErrors()

        if (!paymentConsentsAccepted()) {
            showBillingError(getText('consentsRequired', 'Please accept all required confirmations before continuing.'))
            billingForm.querySelector('.js-ee-business-payment-consent:not(:checked)')?.focus()
            return
        }

        if (!billingForm.checkValidity()) {
            billingForm.reportValidity()
            return
        }

        setLoading(true)

        try {
            const response = await fetch(config.prepareUrl || billingForm.action, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'xmlhttprequest',
                },
                body: new FormData(billingForm),
            })
            const payload = await responseToJson(response)
            if (!response.ok) {
                throw new Error(payload.message || getText('genericError', 'Something went wrong. Please try again.'))
            }

            updateSummary(payload.summary)
            setBillingCollapsed(true)
            stripeForm.hidden = false
            initStripe(payload.client_secret)
            stripeForm.scrollIntoView({behavior: 'smooth', block: 'start'})
        } catch (error) {
            if (stripeForm && !stripeForm.hidden) {
                showStripeError(error.message)
            } else {
                showBillingError(error.message)
            }
        } finally {
            setLoading(false)
        }
    }

    async function confirmPayment(event) {
        event.preventDefault()
        clearErrors()

        if (!stripe || !elements) {
            showStripeError(getText('genericError', 'Something went wrong. Please try again.'))
            return
        }

        setLoading(true)

        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: config.returnUrl || window.location.href,
                payment_method_data: {
                    billing_details: billingDetails(),
                },
            },
            redirect: 'if_required',
        })

        if (result.error) {
            setLoading(false)
            showStripeError(result.error.message)
            return
        }

        pollStatus(true)
    }

    async function pollStatus(immediate = false) {
        if (statusTimer) {
            clearTimeout(statusTimer)
        }

        const run = async () => {
            try {
                const response = await fetch(config.statusUrl, {
                    headers: {
                        'Accept': 'application/json',
                        'X-Requested-With': 'xmlhttprequest',
                    },
                })
                const payload = await responseToJson(response)
                if (payload.summary) {
                    updateSummary(payload.summary)
                }
                if (payload.success || payload.status === 'paid') {
                    window.location.href = config.returnUrl || window.location.href
                    return
                }
                if (payload.status === 'failed' || payload.status === 'canceled') {
                    setLoading(false)
                    showStripeError(payload.message || getText('genericError', 'Something went wrong. Please try again.'))
                    return
                }
            } catch (e) {
                setLoading(false)
                showStripeError(getText('genericError', 'Something went wrong. Please try again.'))
                return
            }

            statusTimer = window.setTimeout(run, 1600)
        }

        if (immediate) {
            run()
        } else {
            statusTimer = window.setTimeout(run, 1600)
        }
    }

    billingForm.querySelectorAll('input[name="customer_type"]').forEach((input) => {
        input.addEventListener('change', () => {
            updateCompanyFields()
            markPaymentDetailsChanged()
            scheduleSummaryUpdate()
        }, {passive: true})
    })

    billingForm.querySelectorAll('input:not([name="customer_type"]), select').forEach((input) => {
        input.addEventListener('input', () => {
            markPaymentDetailsChanged()
            if (inputAffectsSummary(input)) {
                scheduleSummaryUpdate()
            }
        }, {passive: true})
        input.addEventListener('change', () => {
            markPaymentDetailsChanged()
            if (inputAffectsSummary(input)) {
                scheduleSummaryUpdate()
            }
        }, {passive: true})
    })

    if (billingEditButton) {
        billingEditButton.addEventListener('click', () => {
            clearErrors()
            setBillingCollapsed(false)
            markPaymentDetailsChanged()
            resetPaymentElement()
            billingForm.scrollIntoView({behavior: 'smooth', block: 'start'})
        })
    }

    billingForm.addEventListener('submit', preparePayment)

    if (stripeForm) {
        stripeForm.addEventListener('submit', confirmPayment)
    }

    termsOpenButtons.forEach((button) => {
        button.addEventListener('click', openTermsModal)
    })

    termsCloseButtons.forEach((button) => {
        button.addEventListener('click', closeTermsModal)
    })

    if (termsAcceptButton) {
        termsAcceptButton.addEventListener('click', acceptTermsModal)
    }

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && termsModal && !termsModal.hidden) {
            closeTermsModal(event)
        }
    })

    updateCompanyFields()
    scheduleSummaryUpdate()

    if (currentClientSecret && stripeForm) {
        try {
            initStripe(currentClientSecret)
            setBillingCollapsed(true)
            stripeForm.hidden = false
        } catch (e) {
            stripeForm.hidden = false
            showStripeError(e.message)
        }
    }
}
